import { render } from "./VVienneve.vue?vue&type=template&id=fdeece9e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VVienneve.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fdeece9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fdeece9e', __exports__)) {
    api.reload('fdeece9e', __exports__)
  }
  
  module.hot.accept("./VVienneve.vue?vue&type=template&id=fdeece9e", () => {
    api.rerender('fdeece9e', render)
  })

}


export default __exports__